<script setup lang="ts">
defineOptions({
	name: 'ChangeAppSection',
})

const { t: $t } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'{company} is constantly innovating the {platform} to provide the best possible experience. As a result, {company} reserves the right to change these {terms} at any time. Any changes to these {terms} will become effective on the {last_date} indicated at the end of this page.',
		{
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			last_date: `“<span class="italic">${$t('Last Updated Date')}</span>”`,
		},
	)
})

const secondHtml = computed(() => {
	return $tThird(
		'Consequently, {company} recommends that {users} review these {terms} prior to using the {platform} or any of the services accessible through the {platform}, and from time to time.',
		{
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			users: `<span class="font-semibold">${$t('Users')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const thirdHtml = computed(() => {
	return $tThird(
		'Continued use of the {platform} after the {last_date} will signify {users} acceptance of and consent to these changes.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			last_date: `“<span class="italic">${$t('Last Updated Date')}</span>”`,
			users: `<span class="font-semibold">${$t('Users’')}</span>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-mynaui:puzzle"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Change to the App') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p v-html="secondHtml"></p>
			<p v-html="thirdHtml"></p>
		</div>
	</section>
</template>
